/*
 * The backend holds a conversation for three minutes while it answers
 * (`MessagePipeline.processConversation`), a window sized to outlast a slow
 * model call plus the work around it. That is the longest a turn is meant to
 * take, so it is the earliest this side may conclude one is no longer coming.
 */
const PIPELINE_TURN_LIMIT_MS = 180_000;

/**
 * How long Wundo may be shown as answering before we stop believing it.
 *
 * Nothing says a turn has ended other than the reply itself arriving, so this
 * is the only way out of the dots when one fails or a push goes missing. It
 * follows the backend's own limit, with room for a finished reply to be
 * written and pushed — anything shorter takes the dots down while the reply is
 * still being written, and it then lands with no warning.
 */
export const TYPING_TIMEOUT_MS = PIPELINE_TURN_LIMIT_MS + 30_000;
